


















import { debounce } from "lodash";
import Vue from "vue";
import Component from 'vue-class-component'
import { Emit, Prop, VModel, Watch } from 'vue-property-decorator'

import ServicesCart from '../../../components/ServicesCart/ServicesCart.vue'
import { ActivateCouponStruct } from '../../../components/ServicesCart/components/CouponCard/types'
import {
  PayInfos,
  Payment,
  PaymentMethods,
  ShortTariffInfo,
  Tariff
} from '../../../components/ServicesCart/logic/types'
import {
  errorNotificationWrapper,
  successNotificationWrapper
} from '../../../logic/helpers/NotificationService'
import TemplateContext from "../includes/TemplateContext";
import PaymentService from '../includes/logic/Payment'
import { PaymentTargetConfig } from '../includes/types/Config'

@Component({
  components: {
    ServicesCart,
  },
})
export default class BuyService extends Vue {
  @VModel() payMethodsTarget!: { targetIdKey: string, config: PaymentTargetConfig }

  @Prop() tariffsImages!: Record<string, string>

  @Emit()
  onPromocodeActivate(paymentMethods: PaymentMethods) {
    return paymentMethods
  }

  @Watch('$route.path')
  onPathChange():void {
    this.getPaymentMethods()
  }

  get multipleTargets() {
    if (this.payMethodsTarget) {
      const targets = this.payMethodsTarget.config.target_id[this.payMethodsTarget.targetIdKey]

      return Array.isArray(targets) && targets.length > 1
    } else {
      return false
    }
  }

  @Emit()
  updatePayInfo(info: Array<ShortTariffInfo>): PayInfos {
    const diff = +info[0].base_price - +info[0].price
    const sale = ((diff * 100) / +info[0].base_price).toFixed(1)

    const tariffs = info.map(d => {
      return {
        ...d,
        total: +d.price * this.payMethodsTarget.config.target_id[this.payMethodsTarget.targetIdKey].length
      }
    })

    return {
      sale,
      tariffs
    }
  }

  tariffs: Array<Tariff> | null = null

  isLoading = false

  get tariffImages():any {
    if (this.tariffsImages) {
      return this.tariffsImages
    } else {
      const resultObject = {}

      for (const [ key, value ] of Object.entries(this.$store.state.AdminTemplate.applicationConfig.serviceData.tariffs)) {
        this.$set(resultObject, key, (value as any).img)
      }
      return resultObject
    }
  }

  calcTotalFn(price: string) {
    const payMethodsTarget = this.payMethodsTarget

    if (payMethodsTarget) {
      return +price * payMethodsTarget.config.target_id[payMethodsTarget.targetIdKey].length
    }
  }

  async activateCoupon(promocode: ActivateCouponStruct): Promise<void> {
    const { target_id, target_type } = await this.getRequestBody()

    try {
      const { data } = await PaymentService.runCoupon(
        target_id,
        target_type,
        promocode.coupon,
      )

      if ('promocode_success' in data) {
        successNotificationWrapper(this.$t('promocode_activated_success_title', [ data.promocode_success ]).toString(), '')

        this.onPromocodeActivate(data)
      }

      this.tariffs = data.tariffs
    } catch (error) {
      console.log(error)
      errorNotificationWrapper('', error)
      promocode.error()
    } finally {
      promocode.closeLoading()
    }
  }

  async buy(paymentData: Payment): Promise<void> {
    const { target_id, target_type } = await this.getRequestBody()

    if ('fbq' in window) {
      (window as any).fbq(
        'track',
        'Purchase',
        {
          currency: paymentData.getaway.currency_short_name,
          value: paymentData.getaway.price,
        },
      )
    }

    try {
      this.isLoading = true
      await new PaymentService(
        target_id,
        target_type,
        paymentData.tariff.name,
        paymentData.getaway.code,
        paymentData.tariff.monthCount,
        paymentData.requiredFields || {},
      ).createPayment(paymentData.coupon || '')
    } catch (error) {
      console.error(error)
      errorNotificationWrapper('', error)
    } finally {
      this.isLoading = false
    }
  }

  async getRequestBody(): Promise<PaymentTargetConfig> {
    if (this.payMethodsTarget) {
      return this.payMethodsTarget.config
    } else {
      const targetType = this.$store.state.AdminTemplate.applicationConfig.meta.paymentEntity?.target_type

      if (typeof targetType === 'function') {
        return await targetType(new TemplateContext(this.$route));
      } else {
        throw new Error('Payment config not set')
      }
    }
  }

  async getPaymentMethods() {
    try {
      this.isLoading = true

      const reqBody = await this.getRequestBody()
      const { data } = await PaymentService.getPayMethods(reqBody)
      this.tariffs = data.tariffs
    } catch (error) {
      console.error(error)
      errorNotificationWrapper('', error)
    } finally {
      this.isLoading = false
    }
  }

  created(): void {
    this.$watch('payMethodsTarget.config', debounce(this.getPaymentMethods, 500), {
      deep: true
    })

    this.getPaymentMethods()
  }
}
